import { Box, IconButton } from "@chakra-ui/react";
import useTable from "hooks/use-table";
import { FC } from "react";
import { BiSortAlt2, BiSortDown, BiSortUp } from "react-icons/bi";
import { VscSettingsGear } from "react-icons/vsc";

import "./style.css";

interface ITableGridHeader {
  selected?: any;
  isModal?: boolean;
  isActions?: boolean;
  updateIsModalConfig?: () => void;
}

const TableGridHeader: FC<ITableGridHeader> = ({
  isModal,
  selected,
  isActions = true,
  updateIsModalConfig,
}) => {
  const {
    actions,
    columns,
    handleOrder,
    order,
    itsSortable,
    itsSortableGroup,
  } = useTable();

  const handleMouseDown = (event: any) => {
    const widthElement = event.target.getBoundingClientRect()?.width;

    document.querySelectorAll(".td-element").forEach((item: any) => {
      if (event.target.id === item.id) {
        item.style.width = "100%";
        item.style.minWidth = "0px";
        item.style.maxWidth = "0px";
        item.style.whiteSpace = "nowrap";
        item.style.overflow = "hidden";
        item.style.textOverflow = "ellipsis";

        item.children[0].style.overflow = "hidden";
        item.children[0].style.textOverflow = "ellipsis";
      }
    });

    event.target.style.width = `${widthElement}px`;
  };

  return (
    <thead
      style={{
        background: "#EDF2F7",
        position: "sticky",
        top: 0,
        zIndex: 1,
      }}
    >
      <tr className="actions">
        <td
          rowSpan={2}
          color="gray.700"
          key={`action-header`}
          colSpan={1}
          scope="colgroup"
        >
          {"\u00A0"}
          {"\u00A0"}
          {"\u00A0"}
          {"\u00A0"}
          {"\u00A0"}
          {"\u00A0"}
          {"\u00A0"}
        </td>
        {columns.map((item) => {
          if (!item.id) {
            return (
              <th
                color="gray.700"
                key={`${item.group
                  .split(" ")
                  .join("-")
                  .toLocaleLowerCase()!}-header`}
                colSpan={item.columns!.length}
                scope="colgroup"
              >
                {item.group}
              </th>
            );
          }

          return (
            <td
              color="red"
              rowSpan={2}
              key={item.id + "+header"}
              align={item.align || "left"}
            >
              {itsSortableGroup && (
                <IconButton
                  aria-label="Order"
                  icon={
                    order.column !== item.id ? (
                      <BiSortAlt2 />
                    ) : order.sort === "asc" ? (
                      <BiSortUp />
                    ) : (
                      <BiSortDown />
                    )
                  }
                  size="xs"
                  mr={2}
                  onClick={() => {
                    handleOrder(item.id);
                  }}
                />
              )}
              {item.group}
            </td>
          );
        })}
      </tr>
      <tr className="hearder__th">
        {columns.map((item) => {
          const { align, columns } = item;

          return columns!.map((column) => (
            <th
              className="hearder__th"
              key={`${column.id}-header`}
              align={align || "left"}
              scope="col"
            >
              <Box
                id={column.id}
                className="hearder__text-container"
                onMouseDownCapture={(event) => handleMouseDown(event)}
              >
                {itsSortable && (
                  <IconButton
                    aria-label="Order"
                    icon={
                      order.column !== column.id ? (
                        <BiSortAlt2 />
                      ) : order.sort === "asc" ? (
                        <BiSortUp />
                      ) : (
                        <BiSortDown />
                      )
                    }
                    size="xs"
                    mr={2}
                    onClick={() => {
                      handleOrder(column.id);
                    }}
                  />
                )}

                <span className="hearder__text">{column.name}</span>
              </Box>
            </th>
          ));
        })}
      </tr>
    </thead>
  );
};

export default TableGridHeader;
